<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.cep"
                        label="CEP"
                        v-mask="mask.cep"
                        v-model="data.model.endereco.cep"
                        validation-mode="lazy-change"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-button
                                @click="$refs.ModalLogradouro.open()"
                                color="primary"
                                title="Cadastrar logradouro"
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>

                        <rkm-input-group-append slot="append">
                            <rkm-button
                                @click="$refs.ModalBuscaLogradouro.open()"
                                color="outline-primary"
                                title="Buscar logradouro"
                            >
                                <rkm-icon icon="search" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :disabled="!data.model.endereco.cep"
                        :repository="repositories.logradouro"
                        :request-query-string-params="autocompleteParams.logradouro"
                        :search-fields="autocompleteFields.logradouro"
                        :validations="validations.logradouro"
                        label="Logradouro"
                        text-field="tipoNome"
                        uppercase
                        v-model="data.model.endereco.logradouro"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!data.model.endereco.cep || data.model.endereco.semNumero"
                        :validations="validations.numero"
                        label="Número"
                        number
                        v-model="data.model.endereco.numero"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox
                                    :disabled="!data.model.endereco.cep"
                                    inline
                                    v-model="data.model.endereco.semNumero"
                                >
                                    Sem número
                                </rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :disabled="!data.model.endereco.cep"
                        :validations="validations.complemento"
                        label="Complemento"
                        uppercase
                        v-model="data.model.endereco.complemento"

                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :disabled="!data.model.endereco.cep"
                        :validations="validations.referencia"
                        label="Ponto de referência"
                        uppercase
                        v-model="data.model.endereco.referencia"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :value="bairro"
                        disabled
                        label="Bairro"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :value="municipioUf"
                        disabled
                        label="Município / UF"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ModalLogradouro
            @save="loadLogradouro"
            ref="ModalLogradouro"
        />

        <ModalBuscaLogradouro
            @select="loadLogradouro"
            ref="ModalBuscaLogradouro"
        />
    </div>
</template>

<script>
// Components.
import ModalLogradouro from '@/components/cadastro/logradouro/Modal'
import ModalBuscaLogradouro from '@/components/cadastro/logradouro/busca/Modal'

// Mixins.
import { repository, mask, unmask, formats, importacaoCns } from '@/mixins'

export default {
    components: {
        ModalLogradouro,
        ModalBuscaLogradouro,
    },
    computed: {
        validations() {

            return {
                cep: {
                    min_max_without_mask: 8,
                    has_cep: true,
                },
                logradouro: {
                    required: !!this.data.model.endereco.cep
                },
                numero: {
                    required: !!this.data.model.endereco.cep && !this.data.model.endereco.semNumero,
                    max: 6
                },
                complemento: {
                    min: 3,
                    max: 180,
                    regex: this.importacaoCns.regexValidacao,
                    termo_invalido: this.data.additionals.termosInvalidos,
                },
                referencia: {
                    max: 150,
                    regex: this.importacaoCns.regexValidacao,
                    termo_invalido: this.data.additionals.termosInvalidos,
                },
            }
        },
        autocompleteFields() {

            return {
                logradouro: [
                    { key: 'tipo.descricao', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            }
        },
        autocompleteParams() {

            return {
                logradouro: {
                    cep: this.data.model.endereco.cep ? this.unMaskCep(this.data.model.endereco.cep) : null,
                },
            }
        },
        bairro() {

            if (this.data.model.endereco.logradouro) {

                return this.data.model.endereco.logradouro.bairro.nome
            }

            return null
        },
        municipioUf() {

            if (this.data.model.endereco.logradouro) {

                return this.data.model.endereco.logradouro.municipio.nome
                    + ' / '
                    + this.data.model.endereco.logradouro.municipio.estado.uf
            }

            return null
        },

    },
    created() {

        this.repositories = {
            logradouro: this.getConectaSusRepository('cadastro.localizacao.logradouro')
        }
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
        loadLogradouro(logradouro) {

            this.data.model.endereco.cep = this.formatCep(logradouro.cep)

            this.$nextTick(() => this.data.model.endereco.logradouro = logradouro)
        },
    },
    mixins: [ repository, mask, unmask, formats, importacaoCns ],
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'data.model.endereco.cep': function (cep) {

            this.data.model.endereco.logradouro = null

            if (!cep) {

                this.data.model.endereco.numero = null
                this.data.model.endereco.semNumero = false
                this.data.model.endereco.complemento = null
                this.data.model.endereco.referencia = null
            }
        },
        'data.model.endereco.semNumero': function (semNumero) {

            if (semNumero) {

                this.data.model.endereco.numero = null
            }
        },
    }
}
</script>